/* import __COLOCATED_TEMPLATE__ from './ai-disclosure-banner.hbs'; */
/* RESPONSIBLE TEAM: team-email */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency-decorators';
import { tracked } from '@glimmer/tracking';
import { taskFor } from 'ember-concurrency-ts';
import { get, post } from 'embercom/lib/ajax';
import type Session from 'embercom/services/session';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    wrapperClass?: string;
  };
}

export default class AiAgentAiDisclosureBanner extends Component<Signature> {
  constructor(owner: any, args: any) {
    super(owner, args);
    taskFor(this.checkAiDisclosureBannerDismissal).perform();
  }

  @service declare appService: { app: { id: string } };
  @service declare session: Session;
  @tracked showAiDisclosureBanner = false;

  @task({ drop: true })
  *checkAiDisclosureBannerDismissal() {
    try {
      let response: { dismissed: boolean } = yield get(
        `/ember/ai_disclosure_banner?app_id=${this.appService.app.id}&admin_id=${this.session.teammate.id}`,
      );
      this.showAiDisclosureBanner = !response.dismissed;
    } catch (error) {
      // If the endpoint fails, default to showing the banner
      this.showAiDisclosureBanner = true;
    }
  }

  @task({ drop: true })
  *dismissAiDisclosureBanner() {
    try {
      yield post(
        `/ember/ai_disclosure_banner/dismiss?app_id=${this.appService.app.id}&admin_id=${this.session.teammate.id}`,
      );
      this.showAiDisclosureBanner = false;
    } catch (error) {
      // If the dismiss fails, still hide the banner for this session
      this.showAiDisclosureBanner = false;
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::AiDisclosureBanner': typeof AiAgentAiDisclosureBanner;
    'ai-agent/ai-disclosure-banner': typeof AiAgentAiDisclosureBanner;
  }
}
